import { render, staticRenderFns } from "./PayItem3.vue?vue&type=template&id=23814a5c&scoped=true&"
import script from "./PayItem3.vue?vue&type=script&lang=js&"
export * from "./PayItem3.vue?vue&type=script&lang=js&"
import style0 from "./PayItem3.vue?vue&type=style&index=0&id=23814a5c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23814a5c",
  null
  
)

export default component.exports